import { useAtom } from '@xstate/store/react';

import {
	addNotification,
	appendTextPreview,
	clearRovoMessage,
	clearTextPreview,
	closeHer,
	herState,
	type HerNotification,
	type HerRovoMessage,
	type HerTask,
	openHer,
	removeNotification,
	setAnimating,
	setExpanded,
	setRovoMessage,
	toggleHer,
} from '../state/HerState';

export const useHerStore = (): {
	// State
	isHerActive: boolean;
	isExpanded: boolean;
	isAnimating: boolean;
	contentId: string | null;
	contentType: string;
	cloudID: string;
	textPreview: string;
	tasks: Record<string, HerTask>;
	notifications: Record<string, HerNotification>;
	rovoMessage: HerRovoMessage | null;
	// Actions
	toggleHer: (contentId?: string, cloudID?: string, contentType?: string) => void;
	openHer: (contentId?: string, cloudID?: string, contentType?: string) => void;
	closeHer: () => void;
	setExpanded: (expanded: boolean) => void;
	setAnimating: (animating: boolean) => void;
	appendTextPreview: (text: string) => void;
	clearTextPreview: () => void;
	addNotification: (notification: HerNotification) => void;
	removeNotification: (id: string) => void;
	setRovoMessage: (message: HerRovoMessage) => void;
	clearRovoMessage: () => void;
} => {
	const state = useAtom(herState);

	return {
		// State
		isHerActive: state.isHerActive,
		isExpanded: state.isExpanded,
		isAnimating: state.isAnimating,
		contentId: state.contentId,
		contentType: state.contentType,
		cloudID: state.cloudID,
		textPreview: state.textPreview,
		tasks: state.tasks,
		notifications: state.notifications,
		rovoMessage: state.rovoMessage,

		// Actions
		toggleHer,
		openHer,
		closeHer,
		setExpanded,
		setAnimating,
		appendTextPreview,
		clearTextPreview,
		addNotification,
		removeNotification,
		setRovoMessage,
		clearRovoMessage,
	};
};
